import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

// components
import { Button, Form, Card, CardBody, CardHeader, FormGroup, Row, Col, Input } from "reactstrap";
import MaterialTable from 'material-table';
import Select from 'react-select'

// style
import { table_translate, table_style } from "../../../constants/MaterialTable.js";

// helpers
import { showMessage } from "../../../helpers/message.js";
import { formateDateApi, formateDate } from "../../../helpers/formats.js";

// api
import formulariovistoria_api from "../../../api/formulariovistoria_api.js";
import concessionaria_api from "../../../api/concessionaria_api.js";
import regional_api from "../../../api/regional_api.js";
import boletimvistoria_api from "../../../api/boletimvistoria_api.js";
import contrato_api from '../../../api/contrato_api.js';

export default function VistoriaOnlineIdentificacao({ handleAvancar }) {

    const { register, errors, handleSubmit, setValue, clearErrors, getValues } = useForm({ mode: "onBlur" });

    // Formulário
    const [isLoadingFormularios, set_isLoadingFormularios] = useState(false);
    const [options_formularioVistoria, set_options_formularioVistoria] = useState([]);
    const loadListFormularios = (contrato_Id) => {
        set_isLoadingFormularios(true);
        formulariovistoria_api.getListFromWeb(contrato_Id).then(result => {
            set_isLoadingFormularios(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_options_formularioVistoria(result.data);
            }
        });
    }
    const [formularioVistoria, set_formularioVistoria] = useState(null);
    const handleChangeFormularioVistoria = (value) => {
        setValue("formularioVistoria", value);
        set_formularioVistoria(value);
        clearErrors("formularioVistoria");
        if (value.informarRegional)
            loadListRegionais();
        else
            set_regional(null);
    }

    // Concessionária
    const [isLoadingConcessionarias, set_isLoadingConcessionarias] = useState(false);
    const [options_concessionaria, set_options_concessionaria] = useState([]);
    const loadListConcessionarias = () => {
        set_isLoadingConcessionarias(true);
        concessionaria_api.getByUsuarioId().then(result => {
            set_isLoadingConcessionarias(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_options_concessionaria(result.data);
            }
        });
    }
    const [concessionaria, set_concessionaria] = useState(null);
    const handleChangeConcessionaria = (value) => {
        setValue("concessionaria", value);
        set_concessionaria(value);
        clearErrors("concessionaria");
        set_contrato(null);
        setValue("contrato", null, true);
        setValue("formularioVistoria", null);
        set_formularioVistoria(null);
        set_options_formularioVistoria([]);
        loadContratos(value.concessionaria_Id);
    }

    // Regional
    const [isLoadingRegional, set_isLoadingRegional] = useState(false);
    const [options_regional, set_options_regional] = useState([]);
    const loadListRegionais = () => {
        if (options_regional.length == 0) {
            set_isLoadingRegional(true);
            regional_api.getAllWithoutGeoJson().then(result => {
                set_isLoadingRegional(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    set_options_regional(result.data);
                }
            });
        }
    }
    const [regional, set_regional] = useState(null);
    const handleChangeRegional = (value) => {
        setValue("regional", value);
        set_regional(value);
        clearErrors("regional");
        concessionaria_api.getConcessionariaRegionais().then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let concessionaria = result.data.filter(f => f.regional_Id == value.regional_Id);
                if (concessionaria.length > 0)
                    set_concessionaria(options_concessionaria.filter(f => f.concessionaria_Id == concessionaria[0].concessionaria_Id)[0]);
            }
        });
    }

    // Boletins vinculados para análise
    const [isLoadingBoletinsVinculados, set_isLoadingBoletinsVinculados] = useState(false);
    const [list_table, set_list_table] = useState([]);
    const [list_boletinsSelecionados, set_list_boletinsSelecionados] = useState([]);
    const handlePesquisarBoletins = () => {
        if (concessionaria == null) {
            showMessage("Aviso", "Selecione a concessionária", 'error', null);
            return;
        }

        let data = getValues();

        let json_submit = {
            inicio: formateDateApi(data.dataInicial),
            fim: formateDateApi(data.dataFinal),
            concessionaria_Id: concessionaria.concessionaria_Id,
            formularioVistoria_Id: formularioVistoria.formularioVistoriaVinculado_Id
        }

        set_isLoadingBoletinsVinculados(true);
        boletimvistoria_api.postByFilter(json_submit).then(result => {
            set_isLoadingBoletinsVinculados(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_list_table(result.data);
            }
        });
    }

    //Função de busca dos contratos
    const [options_contratos, set_options_contratos] = useState([]);
    const loadContratos = (concessionaria_Id) => {
        set_isLoadingFormularios(true);
        contrato_api.getAll(concessionaria_Id).then(response => {
            set_isLoadingFormularios(false);
            if (response.status !== 200) {
                showMessage("Aviso", response.message, 'error', null);
            }
            else {
                response.data = response.data.map(value => {
                    value.identificacao = value.identificacao + " ( " + value.numeroProcesso + " )";
                    return value;
                })
                set_options_contratos(response.data);
            }
        })
    }
    const [contrato, set_contrato] = useState([]);
    const handleChangeContrato = (value) => {
        setValue("contrato_Id", value.contrato_Id);
        set_contrato(value);
        clearErrors("contrato_Id");
        loadListFormularios(value.contrato_Id);
    }
    useEffect(() => {
        loadListConcessionarias();
    }, []);

    const onSubmit = (data) => {
        let obj = {
            formularioVistoria_Id: formularioVistoria.formularioVistoria_Id,
            regional_Id: regional != null ? regional.regional_Id : null,
            concessionaria_Id: concessionaria.concessionaria_Id,
            contrato_Id: data.contrato_Id,
            boletinsVinculados: list_boletinsSelecionados
        }
        handleAvancar(obj);
    }

    return (
        <>
            <Card>
                <CardHeader>
                    <h5 className="subtitleCard">Identificação do Boletim de Vistoria</h5>
                </CardHeader>
                <CardBody>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <Row className="align-items-end">
                            <Col lg="6" md="6" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Selecione a Concessionária</label>
                                    <Select
                                        name="concessionaria"
                                        options={options_concessionaria}
                                        getOptionLabel={o => o.identificacao}
                                        getOptionValue={o => o.concessionaria_Id}
                                        value={concessionaria}
                                        isLoading={isLoadingConcessionarias}
                                        onChange={(o) => handleChangeConcessionaria(o)}
                                        classNamePrefix="select"
                                        placeholder="Nenhum"
                                        ref={e => register(
                                            { name: "concessionaria" },
                                            { required: regional != null ? false : true })
                                        }
                                        isDisabled={regional != null ? true : false}
                                    />
                                    {errors.concessionaria && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </FormGroup>
                            </Col>
                            <Col lg="6" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Selecione o Contrato</label>
                                    <Select
                                        name="contrato_Id"
                                        options={options_contratos}
                                        getOptionLabel={o => o.identificacao}
                                        getOptionValue={o => o.contrato_Id}
                                        value={contrato}
                                        onChange={(o) => handleChangeContrato(o)}
                                        classNamePrefix="select"
                                        placeholder="Nenhum"
                                        isLoading={isLoadingFormularios}
                                        ref={e => register(
                                            { name: "contrato_Id" },
                                            { required: true })
                                        }
                                    />
                                    {errors.formularioVistoria && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </FormGroup>
                            </Col>
                            <Col lg="12" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Selecione o Formulário</label>
                                    <Select
                                        name="formularioVistoria"
                                        options={options_formularioVistoria}
                                        getOptionLabel={o => o.identificacao}
                                        getOptionValue={o => o.formularioVistoria_Id}
                                        value={formularioVistoria}
                                        onChange={(o) => handleChangeFormularioVistoria(o)}
                                        classNamePrefix="select"
                                        placeholder="Nenhum"
                                        isLoading={isLoadingFormularios}
                                        ref={e => register(
                                            { name: "formularioVistoria" },
                                            { required: true })
                                        }
                                    />
                                    {errors.formularioVistoria && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </FormGroup>
                            </Col>
                            {formularioVistoria && formularioVistoria.informarRegional &&
                                <Col lg="4" md="6" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Selecione a Regional</label>
                                        <Select
                                            name="regional"
                                            options={options_regional}
                                            getOptionLabel={o => o.identificacao}
                                            getOptionValue={o => o.regional_Id}
                                            value={regional}
                                            isLoading={isLoadingRegional}
                                            onChange={(o) => handleChangeRegional(o)}
                                            classNamePrefix="select"
                                            placeholder="Nenhum"
                                            ref={e => register(
                                                { name: "regional" },
                                                { required: formularioVistoria.informarRegional })
                                            }
                                        />
                                        {errors.regional && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                            }

                        </Row>
                        <Row className={formularioVistoria && formularioVistoria.formularioVistoriaVinculado_Id != null ? "" : "d-none"}>
                            <Col lg="12" md="12" sm="12">
                                <h5 className="subtitleCard">Boletins Vinculados para Análise</h5>
                            </Col>
                            <Col lg="3" md="4" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Data vistoria inicial</label>
                                    <Input className="form-control"
                                        autocomplete="off"
                                        type="date"
                                        name="dataInicial"
                                        innerRef={register({ required: false })}
                                    />
                                    {errors.dataInicial && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </FormGroup>
                            </Col>
                            <Col lg="3" md="4" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Data vistoria final</label>
                                    <Input className="form-control"
                                        autocomplete="off"
                                        type="date"
                                        name="dataFinal"
                                        innerRef={register({ required: false })}
                                    />
                                    {errors.dataFinal && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </FormGroup>
                            </Col>
                            <Col lg="6" md="4" sm="12">
                                <br />
                                <Button color="info" type="button" onClick={handlePesquisarBoletins}><i className="fas fa-search"></i> Pesquisar</Button>
                            </Col>
                            <Col lg="12" md="12" sm="12">
                                <MaterialTable style={{ minHeight: "auto" }}
                                    title=""
                                    columns={[
                                        { title: 'Data Vistoria', field: 'dataVistoria', render: (rowData) => formateDate(rowData.dataVistoria) },
                                        { title: 'Contratada', field: 'concessionaria' },
                                        { title: 'Regional', field: 'regional' },
                                        { title: 'Agente Fiscalizador', field: 'usuarioFiscal_Nome' },
                                        { title: 'Formulário', field: 'formularioVistoria_Identificacao' },
                                    ]}
                                    data={list_table}
                                    isLoading={isLoadingBoletinsVinculados}
                                    options={{
                                        filtering: false,
                                        exportButton: true,
                                        selection: true
                                    }}
                                    onSelectionChange={(rows) => set_list_boletinsSelecionados(rows)}
                                    localization={table_translate}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="12" md="12" sm="12" className="text-center">
                                <Button color="success" type="submit">
                                    <i className="fas fa-play"></i> Iniciar
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </CardBody>
            </Card>

        </>
    );
}

